import { render, staticRenderFns } from "./SkeletonCard.vue?vue&type=template&id=1feab2e8&scoped=true"
import script from "./SkeletonCard.vue?vue&type=script&lang=js"
export * from "./SkeletonCard.vue?vue&type=script&lang=js"
import style0 from "./SkeletonCard.vue?vue&type=style&index=0&id=1feab2e8&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1feab2e8",
  null
  
)

export default component.exports